// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/onboard-alcohol-service.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/onboard-alcohol-service/onboard-alcohol-service.js';

mount([g0]);
